import { call, put } from "redux-saga/effects";
import { dabFilmsConstants } from "../actions/constants/dabFilmsConstant";
import { exceptionHandler } from "../pages/common/functions";
import DABFilmsService from "../services/api/dabFilmsService";

function* dabFilmsSave(request: any) {
	try {
		const result = yield call(DABFilmsService.dabFilmsSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: dabFilmsConstants.DABFilmsSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: dabFilmsConstants.DABFilmsSaveFailure, payload: res.data });
		}

	} catch (error) {
		yield put({ type: dabFilmsConstants.DABFilmsSaveFailure, payload: error });
	}
}

function* dabFilmsGetDetail(request: any) {
	try {
		const result = yield call(
			DABFilmsService.dabFilmsGetDetail,
			request.input.id
		);
		console.log(result);
		var res = exceptionHandler(result);

		if (res.status) {
			yield put({
				type: dabFilmsConstants.DABFilmsDetailSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: dabFilmsConstants.DABFilmsDetailFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: dabFilmsConstants.DABFilmsDetailFailure,
			payload: e,
		});
	}
}

function* dabFilmsGetByfilter(request: any) {
	try {
		const result = yield call(DABFilmsService.dabFilmsGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: dabFilmsConstants.DABFilmsGetByfilterSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: dabFilmsConstants.DABFilmsGetByfilterFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: dabFilmsConstants.DABFilmsGetByfilterFailure,
			payload: e,
		});
	}
}

function* dabFilmsDelete(request: any) {
	try {
		const result = yield call(DABFilmsService.dabFilmsDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: dabFilmsConstants.DABFilmsDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: dabFilmsConstants.DABFilmsDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: dabFilmsConstants.DABFilmsDeleteFailure,
			payload: error,
		});
	}
}

function* dabFilmsVideoStatusUpdate(input: any) {
	try {
		const result = yield call(DABFilmsService.dabFilmsVideoStatusUpdate, input.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({ type: dabFilmsConstants.DABFilmsVideoStatusUpdateSuccess, payload: res.data });
		}
		else {
			yield put({ type: dabFilmsConstants.DABFilmsVideoStatusUpdateFailure, payload: res.data });
		}
	}
	catch (e) {
		yield put({ type: dabFilmsConstants.DABFilmsVideoStatusUpdateFailure, payload: e });
	}
}

export const dabFilmsSaga = {
	dabFilmsGetDetail,
	dabFilmsGetByfilter,
	dabFilmsDelete,
	dabFilmsVideoStatusUpdate,
	dabFilmsSave
};
